import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'sign-appointment-consent',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: [
    'consents',
    {
      type: 'payload',
      selector: ['consentId'],
    },
    'user_consent_info',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/sign-appointment-consent-req.js